import {WebWidgetCreateResponse} from '../../../../api/proto';
import i18n from '../../../../i18n';

const {t} = i18n;

export const getWebWidgetError = (type?: WebWidgetCreateResponse.Result | null): string => {
  switch (type) {
    case WebWidgetCreateResponse.Result.INCORRECT_PROPS:
      return t('api_web_widget_incorrect_props');
    case WebWidgetCreateResponse.Result.UNKNOWN:
      return t('api_web_widget_unknown_error');
  }

  if (type && WebWidgetCreateResponse.Result[type]) {
    return WebWidgetCreateResponse.Result[type]?.toLowerCase().replace(/_/g, ' ');
  }

  return '';
};

export default getWebWidgetError;
